import { render } from "./LowestAndHighestQuotas.vue?vue&type=template&id=1c6fc232&scoped=true"
import script from "./LowestAndHighestQuotas.vue?vue&type=script&lang=js"
export * from "./LowestAndHighestQuotas.vue?vue&type=script&lang=js"

import "./LowestAndHighestQuotas.vue?vue&type=style&index=0&id=1c6fc232&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c6fc232"]])

export default __exports__